import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取记录信息
export const getTransactionsData = async (params: object) => {
  // return POSTFORM({
  //     url: Api.getTransactionsData,
  //     data:params.formData,
  //     showError: false
  // })
  return await GET({
    url: Api.getTransactionsData,
    params: {
      ...params
    },
    // headers:{
    //     rpcType:"dubbo",
    // },
    showError: false
  })
}
